import {
  VariantDetail,
  Sample,
  fetchVariantDetails,
  fetchAnalysisVariantDetails
} from '@/@core/services/app.service'
import {
  formatVariantInheritance,
  isJson,
  isWindow,
  unique
} from '@/@core/utils/utils'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CardContent
} from '@mui/material'
import {} from 'antd'
import { Box, Grid, Chip, Card, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import Index from '../Index'
import ClinicalSynopsisDetail from '../VariationGene/ClinicalSynopsisDetail'

interface Column {
  id: string
  label: string
  minWidth?: number
  align?: 'right' | 'left' | 'center'
  format?: (value: any) => any
}

export const OMIM = (props: {
  params: any
  setBackop: any
  analysisInfo: any
}) => {
  const router = useRouter()
  const { t, i18n } = useTranslation()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

  const [variantDetail, setVariantDetails] = React.useState<VariantDetail>()

  const terms = React.useMemo<any[]>(() => {
    if (
      props.analysisInfo &&
      props.analysisInfo.terms &&
      isJson(props.analysisInfo.terms)
    ) {
      return JSON.parse(props.analysisInfo.terms)
    } else if (props.analysisInfo && props.analysisInfo.samples) {
      return props.analysisInfo.samples
        .map((sample: Sample) => sample.terms)
        .flat()
    } else if (
      props.analysisInfo &&
      props.analysisInfo.terms &&
      Array.isArray(props.analysisInfo.terms)
    ) {
      return props.analysisInfo.terms
    } else return []
  }, [props.analysisInfo])

  const { data } = useQuery<VariantDetail>(
    ['variantDetails'],
    async () => {
      if (props.params.chrom && props.params.pos) {
        const variants = {
          chrom: props.params.chrom,
          pos: props.params.pos,
          REF: props.params.REF ?? props.params.ref,
          ALT: props.params.ALT ?? props.params.alt,
          gene: props.params.gene,
          genomeBuild: props.analysisInfo.genomeBuild
        }

        if (type === 'sample')
          return await fetchVariantDetails({
            sampleId: id as unknown as number,
            variants
          })
        else {
          const analysisItemType = localStorage.getItem('analysisItemType')

          return await fetchAnalysisVariantDetails({
            analysisId: id as unknown as number,
            variants: {
              ...variants,
              analysisItemType
            }
          })
        }
      }
    },
    {
      keepPreviousData: true,
      onSuccess: (variantDetails) => {
        const omimData = props.params.OMIM?.omimData
        const geneDiseaseTranslated =
          props.params.OMIM?.geneDiseaseTranslated?.data
        const OMIMData1 = props.params.OMIM?.omimData
          ? props.params.OMIM?.omimData
          : props.params.omim_phenotypes
          ? props.params.omim_phenotypes
          : props.params.omim_genes
          ? props.params.omim_genes
              .map((item: any) => item.omim_phenotypes)
              .flat()
          : props.params.oldOMIMData
          ? props.params.oldOMIMData
          : []
        const oldOMIMData = OMIMData1.map((item: any) => {
          const inheritances: string[] = []
          const clinicalSynopsiss = isJson(item.clinical_synopsis)
            ? JSON.parse(item.clinical_synopsis)
            : item.clinicalSynopsis

          if (
            item &&
            clinicalSynopsiss &&
            clinicalSynopsiss.INHERITANCE &&
            Array.isArray(clinicalSynopsiss.INHERITANCE)
          ) {
            clinicalSynopsiss.INHERITANCE.forEach((str: string) =>
              inheritances.push(str.toLowerCase())
            )
          }
          const inheritance = formatVariantInheritance(
            Array.from([...new Set(inheritances)]).join(',')
          )
          item.clinicalSynopsis = clinicalSynopsiss
          item.phenoName = item.phenoName ?? item.pheno_name
          item.phenoMim = item.phenoMim ?? item.pheno_mim_number
          if (inheritance && clinicalSynopsiss)
            item.inheritance =
              inheritance || inheritance !== ''
                ? inheritance
                : Array.from([...new Set(clinicalSynopsiss.INHERITANCE)]).join(
                    ','
                  )

          return item
        })
        if (variantDetails && variantDetails.clinicalSynopsis.length === 0) {
          variantDetails.clinicalSynopsis = oldOMIMData
          console.log(oldOMIMData)
        }
        if (variantDetails && variantDetails.clinicalSynopsis)
          variantDetails.clinicalSynopsis = unique(
            variantDetails.clinicalSynopsis.map((item: any) => {
              const inheritances: string[] = []
              const clinicalSynopsiss = isJson(item.clinical_synopsis)
                ? JSON.parse(item.clinical_synopsis)
                : item.clinicalSynopsis

              if (
                item &&
                clinicalSynopsiss &&
                clinicalSynopsiss.INHERITANCE &&
                Array.isArray(clinicalSynopsiss.INHERITANCE)
              ) {
                clinicalSynopsiss.INHERITANCE.forEach((str: string) =>
                  inheritances.push(str.toLowerCase())
                )
              }
              const inheritance = formatVariantInheritance(
                Array.from([...new Set(inheritances)]).join(',')
              )

              item.inheritance =
                inheritance || inheritance !== ''
                  ? inheritance
                  : Array.from([
                      ...new Set(clinicalSynopsiss.INHERITANCE)
                    ]).join(',')

              if (omimData && Array.isArray(omimData)) {
                const temp = omimData.find(
                  (items) => item.phenoMim === items.phenoMim
                )

                if (temp) {
                  item.omimData = temp
                }
              }

              return item
            }),
            'phenoName'
          )

        //
        if (variantDetails) setVariantDetails(variantDetails)
      }
    }
  )

  React.useEffect(() => {
    if (
      props.params &&
      props.params.OMIM &&
      props.params.OMIM.omimData &&
      (!props.params.chrom || props.params.STR_Result)
    ) {
      //
      const OMIM = props.params.OMIM.omimData.map((items: any) => {
        return {
          ...items,
          clinicalSynopsis: items.clinicalSynopsis,
          omimData: items,
          geneMim: props.params.OMIM.geneMim,
          geneName: props.params.OMIM.geneName
        }
      })

      //

      setVariantDetails({
        clinicalSynopsis: OMIM
      } as any)
    } else if (
      props.params &&
      props.params.omim_info &&
      props.params.OMIMArr &&
      props.params.OMIMArr.length
    ) {
      const OMIM = props.params.OMIMArr.map((item: any) => item.omimData)
        .flat()
        .map((items: any) => {
          return {
            ...items,
            clinicalSynopsis: items.clinicalSynopsis,
            omimData: items,
            geneMim: props.params.OMIMArr[0].geneMim,
            geneName: props.params.OMIMArr[0].geneName
          }
        })

      //

      setVariantDetails({
        clinicalSynopsis: OMIM
      } as any)
    } else if (
      props.params &&
      props.params.omim_genes &&
      props.params.omim_genes.length
    ) {
      const OMIM = props.params.omim_genes
        .map((item: any) => item.omim_phenotypes)
        .flat()
        .map((items: any) => {
          console.log(items)
          return {
            ...items,
            phenoMim: items.gene_mim_number,
            phenoName: items.pheno_name,
            clinicalSynopsis: isJson(items.clinical_synopsis)
              ? JSON.parse(items.clinical_synopsis)
              : {},
            omimData: items
          }
        })

      //

      setVariantDetails({
        clinicalSynopsis: OMIM
      } as any)
    }
  }, [props.params])

  const patients = React.useMemo(() => {
    if (
      props.analysisInfo &&
      props.analysisInfo.samples &&
      props.analysisInfo.samples.some(
        (sample: any) => sample.patients && sample.patients.length
      )
    ) {
      return props.analysisInfo.samples
        .map((item: any) => {
          return {
            ...item.patients[0],
            type: item.type,
            clinicalInformation: item.clinicalInformation
          }
        })
        .flat()
    } else return []
  }, [props.analysisInfo])

  const patientColumn: Column[] = [
    { id: 'id', label: 'id', align: 'left' },
    {
      id: 'patientName',
      label: t('patientName'),
      align: 'left',
      format: (value) => {
        return (
          <p
            style={{
              minWidth: 100
            }}
          >
            {value}
          </p>
        )
      }
    },
    {
      id: 'clinicalInformation',
      label: t('Clinical information'),
      align: 'left'
    }

    // {
    //   id: 'userId,',
    //   label: t('userId'),
    //   align: 'left',
    //   format: ((value: any) => {
    //     //

    //     return <Typography>{t(value)}</Typography>
    //   }) as any
    // }
  ]

  const HighlightText = ({
    text,
    keywords
  }: {
    text: string
    keywords: { name_cn: string; name_en: string }[]
  }) => {
    // 收集所有关键词并转义正则特殊字符
    const allKeywords = [
      ...new Set(
        keywords
          .flatMap((item: { name_cn: any; name_en: any }) => [
            item.name_cn,
            item.name_en
          ])
          .filter(Boolean)
      )
    ].map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))

    if (allKeywords.length === 0) return <span>{text}</span>

    // 创建匹配模式（按长度降序）
    const pattern = allKeywords.sort((a, b) => b.length - a.length).join('|')
    const regex = new RegExp(`(${pattern})`, 'g')

    // 分割文本并渲染
    const parts = [] as (string | { text: string; isHighlight: boolean })[]
    let lastIndex = 0

    text.replace(regex, (match: string, _: any, offset: number) => {
      // 添加前面的普通文本
      if (offset > lastIndex) {
        parts.push(text.slice(lastIndex, offset))
      }

      // 添加高亮部分
      parts.push({ text: match, isHighlight: true })

      lastIndex = offset + match.length

      return match
    })

    // 添加最后一段普通文本
    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex))
    }

    return (
      <span>
        {parts.map((part, index) =>
          typeof part === 'string' ? (
            <React.Fragment key={index}>{part}</React.Fragment>
          ) : (
            <span key={index} style={{ color: 'red', fontWeight: 'bold' }}>
              {part.text}
            </span>
          )
        )}
      </span>
    )
  }

  if (variantDetail)
    return (
      <Box height={'100%'}>
        <Grid container spacing={2} height={'100%'}>
          <Grid
            item
            xs={12}
            md={4}
            height={'100%'}
            top={0}
            position={isWindow() ? 'sticky' : 'relative'}
            sx={{
              paddingTop: '0 !important'
            }}
          >
            {patients && patients.length ? (
              <Accordion expanded={true}>
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Typography fontSize={18} fontWeight={600}>
                    {t('Patient information')}：
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Box
                    maxHeight={'500px'}
                    sx={{
                      overflowY: 'auto',
                      p: 2
                    }}
                  >
                    <Index rows={patients} columns={patientColumn} />
                  </Box>
                </AccordionDetails>
              </Accordion>
            ) : (
              ''
            )}

            <Accordion expanded={true}>
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography fontSize={18} fontWeight={600}>
                  {t('phenotype')}：
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Box
                  maxHeight={'500px'}
                  sx={{
                    overflowY: 'auto',
                    p: 2
                  }}
                >
                  {terms.map(
                    (
                      item: {
                        title: string
                        name_en: string
                        hpo_code: string
                      },
                      index
                    ) => {
                      return (
                        <Chip
                          sx={{
                            m: 1,
                            fontSize: '0.875rem',
                            bgcolor: 'primary.main',
                            userSelect: 'text'
                          }}
                          label={
                            i18n && i18n.language === 'zh'
                              ? item.title
                              : `${
                                  item.hpo_code
                                    ? `${item.hpo_code}(${item.name_en})`
                                    : `${item.name_en}`
                                }`
                          }
                          key={`${item.title}_${index}`}
                          color="info"
                        />
                      )
                    }
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>

          <Grid item xs={12} md={8} overflow="auto" maxHeight={'100%'}>
            {props.params.OMIM
              ? i18n &&
                i18n.language === 'zh' &&
                props.params.OMIM?.geneDiseaseTranslated
                ? props.params.OMIM?.geneDiseaseTranslated?.data.map(
                    (item: any) => {
                      return (
                        <Card>
                          <CardContent>
                            <Typography>
                              {`${t('Disease Name')}:${item.disease}(${
                                item.genetic_mode
                              })`}
                            </Typography>

                            <Typography>
                              {`${t('Disease Introduction')}:${
                                item.disease_description_cn
                              }`}
                            </Typography>

                            <Typography>
                              <HighlightText
                                text={`${t('phenotype')}:${item.phenotype}`}
                                keywords={terms}
                              />
                            </Typography>
                          </CardContent>
                        </Card>
                      )
                    }
                  )
                : props.params.OMIM?.omimData.map((item: any) => {
                    const inheritances: string[] = []

                    if (
                      item &&
                      item.clinicalSynopsis &&
                      item.clinicalSynopsis.INHERITANCE &&
                      Array.isArray(item.clinicalSynopsis.INHERITANCE)
                    ) {
                      item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                        inheritances.push(str.toLowerCase())
                      )
                    }
                    const inheritance = formatVariantInheritance(
                      Array.from([...new Set(inheritances)]).join(',')
                    )

                    return (
                      <Card>
                        <CardContent>
                          <Typography>
                            {i18n && i18n.language === 'zh'
                              ? `${t('Disease Name')}:${
                                  item.pheno_name_cn
                                }(${inheritance})`
                              : `${t('Disease Name')}:${
                                  item.phenoName
                                }(${inheritance})`}
                          </Typography>

                          <Typography>
                            {i18n && i18n.language === 'zh'
                              ? `${t(
                                  'Disease Introduction'
                                )}:${item.phenoDescriptionCN
                                  .map((i: any) => i.text)
                                  .join('')}`
                              : `${t(
                                  'Disease Introduction'
                                )}:${item.phenoDescription
                                  .map((i: any) => i.text)
                                  .join('')}`}
                          </Typography>

                          {/* <Typography>
                            <HighlightText
                              text={i18n && i18n.language === 'zh'
                              ? `${t('phenotype')}:${item.phenotype}`
                              : ''}
                              keywords={terms}
                            />
                          </Typography> */}
                        </CardContent>
                      </Card>
                    )
                  })
              : props.params.omim_curate_phenotypes
              ? i18n &&
                i18n.language === 'zh' &&
                props.params.omim_curate_phenotypes
                ? props.params.omim_curate_phenotypes?.map((item: any) => {
                    return (
                      <Card>
                        <CardContent>
                          <Typography>
                            {`${t('Disease Name')}:${
                              item.disease ?? item.pheno_name_cn
                            }(${item.genetic_mode ?? item.inheritance})`}
                          </Typography>

                          <Typography>
                            {`${t('Disease Introduction')}:${
                              item.disease_description_cn ??
                              item.pheno_description_cn
                            }`}
                          </Typography>

                          <Typography>
                            <HighlightText
                              text={`${t('phenotype')}:${
                                item.phenotype ?? item.curated_phenotype
                              }`}
                              keywords={terms}
                            />
                          </Typography>
                        </CardContent>
                      </Card>
                    )
                  })
                : props.params.omim_phenotypes?.map((item: any) => {
                    const inheritances: string[] = []

                    if (
                      item &&
                      item.clinicalSynopsis &&
                      item.clinicalSynopsis.INHERITANCE &&
                      Array.isArray(item.clinicalSynopsis.INHERITANCE)
                    ) {
                      item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                        inheritances.push(str.toLowerCase())
                      )
                    }
                    const inheritance = formatVariantInheritance(
                      Array.from([...new Set(inheritances)]).join(',')
                    )

                    return (
                      <Card>
                        <CardContent>
                          <Typography>
                            {i18n && i18n.language === 'zh'
                              ? `${t('Disease Name')}:${
                                  item.pheno_name_cn
                                }(${inheritance})`
                              : `${t('Disease Name')}:${
                                  item.pheno_name
                                }(${inheritance})`}
                          </Typography>

                          <Typography>
                            {i18n && i18n.language === 'zh'
                              ? `${t('Disease Introduction')}:${
                                  item.pheno_description_cn
                                }`
                              : `${t('Disease Introduction')}:${
                                  item.pheno_description
                                }`}
                          </Typography>

                          {/* <Typography>
                            <HighlightText
                              text={i18n && i18n.language === 'zh'
                              ? `${t('phenotype')}:${item.phenotype}`
                              : ''}
                              keywords={terms}
                            />
                          </Typography> */}
                        </CardContent>
                      </Card>
                    )
                  })
              : props.params.omim_phenotypes
              ? props.params.omim_phenotypes?.map((item: any) => {
                  const inheritances: string[] = []

                  if (
                    item &&
                    item.clinicalSynopsis &&
                    item.clinicalSynopsis.INHERITANCE &&
                    Array.isArray(item.clinicalSynopsis.INHERITANCE)
                  ) {
                    item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                      inheritances.push(str.toLowerCase())
                    )
                  }
                  const inheritance = formatVariantInheritance(
                    Array.from([...new Set(inheritances)]).join(',')
                  )

                  return (
                    <Card>
                      <CardContent>
                        <Typography>
                          {i18n && i18n.language === 'zh'
                            ? `${t('Disease Name')}:${
                                item.pheno_name_cn
                              }(${inheritance})`
                            : `${t('Disease Name')}:${
                                item.pheno_name
                              }(${inheritance})`}
                        </Typography>

                        <Typography>
                          {i18n && i18n.language === 'zh'
                            ? `${t('Disease Introduction')}:${
                                item.pheno_description_cn
                              }`
                            : `${t('Disease Introduction')}:${
                                item.pheno_description
                              }`}
                        </Typography>

                        {/* <Typography>
                            <HighlightText
                              text={i18n && i18n.language === 'zh'
                              ? `${t('phenotype')}:${item.phenotype}`
                              : ''}
                              keywords={terms}
                            />
                          </Typography> */}
                      </CardContent>
                    </Card>
                  )
                })
              : props.params.OMIMArr && props.params.OMIMArr[0]
              ? props.params.OMIMArr[0]?.geneDiseaseTranslated?.data.map(
                  (item: any) => {
                    return (
                      <Card>
                        <CardContent>
                          <Typography>
                            {`${t('Disease Name')}:${item.disease}(${
                              item.genetic_mode
                            })`}
                          </Typography>

                          <Typography>
                            {`${t('Disease Introduction')}:${
                              item.disease_description_cn
                            }`}
                          </Typography>

                          <Typography>
                            <HighlightText
                              text={`${t('phenotype')}:${item.phenotype}`}
                              keywords={terms}
                            />
                          </Typography>
                        </CardContent>
                      </Card>
                    )
                  }
                )
              : ''}

            <ClinicalSynopsisDetail
              value={
                unique(
                  (variantDetail?.clinicalSynopsis as any[]) ?? [],
                  'phenoName'
                ) as Record<string, any>
              }
            />
          </Grid>
        </Grid>
      </Box>
    )
  else
    return (
      <Box>
        <Typography>{t('No Results')}</Typography>
      </Box>
    )
}
